import createError from "~/store/manage/validation/utilities/createError";

const checkForAcceptanceErrors = (item, checks, index, type) => {
  const errors = [];

  checks.forEach((check) => {
    const value = item[check.fieldName];

    const isMissing = value !== true;

    if (isMissing) {
      errors.push(createError(item, check, index, type));
    }
  });

  return errors;
};

export default checkForAcceptanceErrors;
